import { useCurrentCompany } from '@bonusly/who-am-i';

import { useManagerCheckInSettings } from './use-manager-check-in-settings';

/**
 * Hook to determine if check-ins are configured for the current user/company.
 * Not to be used on the team hub pages.
 * Check-ins are considered configured when:
 * 1. The company has mandatory check-ins enabled (and past the effective date), OR
 * 2. A cadence is set by user's manager
 *
 * @returns boolean - true if check-ins are configured, false otherwise
 */
export const useCheckInsConfigured = (): boolean => {
	const company = useCurrentCompany();
	const { data: managerCheckInSettings } = useManagerCheckInSettings();

	// Check if company has mandatory check-ins enabled
	const companyCheckInSettings = company?.check_in_settings;
	const isCompanyMandatory =
		companyCheckInSettings?.mandatory && (!companyCheckInSettings?.effective_date || new Date() >= new Date(companyCheckInSettings.effective_date));

	// Check if a cadence is set by user's manager
	const hasCadence = !!managerCheckInSettings?.cadence;

	return isCompanyMandatory || hasCadence;
};
